import { render, staticRenderFns } from "./GroupMembersTab.vue?vue&type=template&id=e28391f2&"
import script from "./GroupMembersTab.vue?vue&type=script&lang=ts&"
export * from "./GroupMembersTab.vue?vue&type=script&lang=ts&"
import style0 from "./GroupMembersTab.vue?vue&type=style&index=0&id=e28391f2&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports